import { App } from "./game/app";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

const app = new App(root);
app.start().catch((err) => {
  console.error(err);
  const n = document.createElement("pre");
  n.style.cssText = "position:fixed;inset:auto 16px 16px 16px;z-index:99;color:#ff4d2e;font:12px/1.4 monospace;white-space:pre-wrap";
  n.textContent = String(err?.stack ?? err);
  document.body.appendChild(n);
});

window.addEventListener("beforeunload", () => app.dispose());
